import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ApolloQueryResult, OperationVariables } from '@parkchirp/api-client';

import { SetShowDialog, SetShowSnackbar, TenantListItem } from '../../types';
import { RemoveTenantModal } from './removeTenantModal';

interface TenantUsersTableProps {
	subscriptionId: string;
	setShowSnackbar: SetShowSnackbar;
	setShowDialog: SetShowDialog;
	refetchTenants: (variables?: Partial<OperationVariables>) => Promise<ApolloQueryResult<any>>;
	tenantsList?: TenantListItem[];
	tenantSubscriptionId?: string;
	theme: any;
}

export const TenantUsersTable = ({
	tenantsList,
	setShowDialog,
	refetchTenants,
	subscriptionId,
	setShowSnackbar,
	tenantSubscriptionId,
	theme,
}: TenantUsersTableProps) => (
	<TableContainer component={Paper} data-cy='tenant-users-table-container'>
		<Table sx={{ minWidth: 650 }} aria-label='tenant users table'>
			<TableHead>
				<TableRow className='pca__table--header'>
					<TableCell style={{ fontWeight: 'bold' }}>Email</TableCell>
					<TableCell align='center' />
					<TableCell align='center' />
				</TableRow>
			</TableHead>
			<TableBody>
				{tenantsList?.length === 0 ? (
					<TableRow>
						<TableCell style={{ color: 'black' }}>Subscription has no tenant users.</TableCell>
					</TableRow>
				) : null}
				{tenantsList?.map((user) => (
					<TableRow key={user.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						<TableCell component='th' scope='row' style={{ color: 'black' }}>
							{user.userEmail}
						</TableCell>
						<TableCell align='center'>{user.isPayor ? <Chip label='Payor' /> : null}</TableCell>
						<TableCell
							align='center'
							onClick={() => {
								setShowDialog(
									<RemoveTenantModal
										subscriptionId={subscriptionId}
										handleClose={() => setShowDialog(null)}
										email={user.userEmail}
										refetch={refetchTenants}
										setShowSnackbar={setShowSnackbar}
										tenantSubscriptionId={tenantSubscriptionId}
										theme={theme}
									/>,
								);
							}}
						>
							<DeleteForeverIcon
								style={{
									cursor: 'pointer',
									height: '28px',
									width: '28px',
									color: 'black',
								}}
								data-cy='delete-tenant-button'
							/>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	</TableContainer>
);
